module.exports = "## Slider\nA [slider](https://www.google.com/design/spec/components/sliders.html)\nis an interface for users to input a value in a range. Sliders can be continuous\nor discrete and can be enabled or disabled.\n### Examples\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/pages/components/Slider/README.md
 ** module id = 1051
 ** module chunks = 0
 **/